export const LEVELUP_REQUIREMENT = [1, 1, 1, 2, 4, 8, 16, 24, 32, 40]

const PROBABILITY_ONE = [0, 1, 0.7, 0.6, 0.5, 0.4, 0.33, 0.3, 0.24, 0.22, 0.19]

const PROBABILITY_TWO = [0, 1, 1, 0.95, 0.85, 0.75, 0.63, 0.6, 0.54, 0.52, 0.44]

const PROBABILITY_THREE = [0, 1, 1, 1, 1, 0.98, 0.93, 0.9, 0.84, 0.77, 0.69]

const PROBABILITY_FOUR = [0, 1, 1, 1, 1, 1, 1, 1, 0.99, 0.97, 0.94]

export const PROBABILITY = {
  ONE: PROBABILITY_ONE,
  TWO: PROBABILITY_TWO,
  THREE: PROBABILITY_THREE,
  FOUR: PROBABILITY_FOUR,
}

export const CHESS_CLASSES: string[] = [
  'Beast',
  'Demon',
  'Dragon',
  'Dwarf',
  'Elemental',
  'Elf',
  'Goblin',
  'God',
  'Human',
  'Naga',
  'Ogre',
  'Orc',
  'Satyr',
  'Troll',
  'Undead',
  'Assassin',
  'DemonHunter',
  'Druid',
  'Hunter',
  'Knight',
  'Mage',
  'Mech',
  'Priest',
  'Shaman',
  'Warlock',
  'Warrior',
]
